import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-[#00C853] py-20 px-4" data-id="element-103">
      <div className="max-w-3xl mx-auto" data-id="element-104">
        <div className="relative bg-white rounded-3xl p-8 sm:p-12 text-center shadow-2xl overflow-hidden" data-id="element-105">
          {/* Top accent bar */}
          <div className="absolute top-0 left-0 w-full h-2 bg-[#00C853]" data-id="element-106" />

          {/* Decorative corner glow */}
          <div className="absolute -top-16 -right-16 w-48 h-48 bg-[#00C853]/10 rounded-full blur-3xl pointer-events-none" data-id="element-107" />

          {/* Eyebrow badge */}
          <span className="relative inline-block bg-[#00C853] text-white text-[10px] sm:text-xs font-black px-4 py-1.5 rounded-full uppercase tracking-widest shadow-md mb-7" data-id="element-108">
            ✔ Null Risiko · 100% Abgesichert
          </span>

          {/* Shield */}
          <div className="relative inline-flex items-center justify-center mb-7" data-id="element-109">
            <div className="absolute w-28 h-28 bg-[#00C853]/20 rounded-full blur-2xl" data-id="element-110" />
            <div className="relative flex items-center justify-center w-24 h-24 rounded-full bg-[#00C853]/10 border-2 border-[#00C853]/30" data-id="element-111">
              <span className="text-6xl" data-id="element-112">🛡️</span>
            </div>
          </div>

          <h2 className="relative text-3xl sm:text-5xl font-black text-[#0A0A0A] mb-5 tracking-tight" data-id="element-113">
            7 Tage <span className="text-[#00C853]" data-id="element-114">"Hallen-Garantie"</span>
          </h2>

          <p className="relative text-[#0A0A0A] text-xl sm:text-2xl font-black mb-3 leading-snug max-w-xl mx-auto" data-id="element-115">
            Testen Sie das Material in Ihrer Halle. Wenn Sie nicht in den ersten
            7 Tagen spüren, dass BASKETBALL BEREIT 360 Ihnen massiv Zeit spart
            und Ihren Unterricht verbessert,{' '}
            <span className="text-[#00C853]" data-id="element-116">
              erstatten wir Ihnen den vollen Betrag.
            </span>
          </p>

          <p className="relative text-[#5A5A66] text-base font-medium mb-8 max-w-md mx-auto leading-relaxed" data-id="element-117">
            Die Boni dürfen Sie trotzdem behalten —{' '}
            <span className="font-black text-[#0A0A0A] uppercase tracking-wider" data-id="element-118">
              ohne Wenn und Aber.
            </span>
          </p>

          {/* Trust points */}
          <div className="relative flex flex-wrap items-center justify-center gap-x-6 gap-y-3 mb-8 pt-7 border-t border-[#E5E5EA] max-w-lg mx-auto" data-id="element-119">
            {[{
            icon: '⚡',
            label: 'Sofortige Erstattung'
          }, {
            icon: '📝',
            label: 'Keine Formulare'
          }, {
            icon: '🎁',
            label: 'Boni behalten'
          }].map(item => <span key={item.label} className="flex items-center gap-2 text-[#0A0A0A] text-sm font-bold" data-id="element-120">
                <span className="text-base" data-id="element-121">{item.icon}</span>
                {item.label}
              </span>)}
          </div>

          <span className="relative inline-block bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-xs sm:text-sm font-black px-5 py-2.5 rounded-full uppercase tracking-wider" data-id="element-122">
            ⭐ Rückgabequote unter 1%
          </span>
        </div>
      </div>
    </section>;
}